var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight24Px = function SvgArrowRight24Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 10
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "arrow_right_24px_svg__a",
    width: 6,
    height: 10,
    x: 0,
    y: 0,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.5 10 5-5-5-5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#arrow_right_24px_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15-7H-9v24h24z"
  }))));
};
export default SvgArrowRight24Px;